import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import cookie from 'utils/cookie';
import WindowBoxLock from 'components/WindowBoxLock';
import {
  logout,
} from 'containers/App/reducers/userReducer';
import PendingImage from 'images/pending-page.png';

const mapStateToProps = (state) => {
  const { app } = state;
  return {
    application: app.application,
    user: app.user,
  };
};

class EnsureLoggedIn extends Component {
  static get propTypes() {
    return {
      children: PropTypes.node.isRequired,
      application: PropTypes.shape({
        isLoggedIn: PropTypes.bool,
        isLoaded: PropTypes.bool,
        isOtherAccountLoggedIn: PropTypes.bool,
      }).isRequired,
      user: PropTypes.shape({
        isLoaded: PropTypes.bool,
      }).isRequired,
    };
  }
  static get defaultProps() {
    return {
      children: PropTypes.node.isRequired,
    };
  }

  componentDidMount() {
    const { application } = this.props;
    if (!application.isLoggedIn) {
      cookie.removeCookie('PreferenceLanguage');
      logout();
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      application,
    } = nextProps;
    if (!application.isLoggedIn) {
      logout();
    }
  }

  renderLockWin() {
    let container = null;
    container = (
      <WindowBoxLock
        width={400}
        title={
          [<FormattedMessage
            key="1"
            id="SH_Message"
            defaultMessage="訊息"
          />]
        }
      >
        <FormattedMessage id="id" defaultMessage="已有其他身分登入，請關閉本分頁。"/>
      </WindowBoxLock>
    );
    return container;
  }

  renderContent({ application, children } = {}) {
    return (
      <div>
        {application.isOtherAccountLoggedIn && this.renderLockWin()}
        {children}
      </div>
    );
  }
  render() {
    const { props } = this;
    const { application, user, children } = props;

    return (application.isLoggedIn && application.isLoaded && user.isLoaded)
      ? this.renderContent({ application, children })
      : <div className={'container'}><img src={PendingImage }/></div>;
  }
}

export default connect(mapStateToProps)(EnsureLoggedIn);



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/components/EnsureLoggedIn/index.js
 **/